module.exports = __webpack_public_path__ + "efe9f3bd2f6f2bc505aaaa228e2e74e3.pdf";